// extracted by mini-css-extract-plugin
export default {"AppRouter":"AppRouter_AppRouter__Cu3Gi"};